import { CheckoutContextType, ChildrenType } from 'interfaces';
import { createContext, FC, useReducer } from 'react';
import { initialState, staffReducer } from 'reducer/checkoutReducer';

export const CheckoutContext = createContext<CheckoutContextType>({
  state: initialState,
  dispatch: () => {},
});

export const CheckoutContextProvider: FC<ChildrenType> = ({ children }) => {
  const [state, dispatch] = useReducer(staffReducer, initialState);

  return (
    <CheckoutContext.Provider
      value={{
        state,
        dispatch,
      }}>
      {children}
    </CheckoutContext.Provider>
  );
};
